const ENV = process.env.REACT_APP_NODE_ENV;
const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

export const getTypeCurvesApi = async (user) => {

  try {
    console.log(`Fetching type curves for user ${user} from ${ENV} API...`);

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'user': user
      },
    };

    let result = await fetch(`${BASE_URL_SSD}/typecurves`, options);

    if (result.status === 200) {
      return result.json();
    };
  } catch (error) {
    console.log('Error fetching forecast parameters!');
    console.log(error);
    return false;
  };
};

export const getTypeCurveParamsApi = async (typeCurveId, name) => {
  try {
    console.log('Fetching params for type curve ' + name + '...');

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'id': typeCurveId
      },
    };

    let result = await fetch(`${BASE_URL_SSD}/typecurves/params`, options);

    if (result.status === 200) {
      return result.json();
    };
  } catch (error) {
    console.log('Error fetching type curve parameters!');
    console.log(error);
    return false;
  };
};

export const saveTypeCurveApi = async (typeCurve, email) => {
  try {
    console.log('Saving type curve for user ' + email);

    if (typeCurve && typeCurve?.id && typeCurve?.createdBy) {
      console.log('Saving type curve ' + typeCurve?.name + ' to the database...');
      
      let newTypeCurve = {...typeCurve, lastModified: new Date()};
      delete newTypeCurve.forecast;
      delete newTypeCurve.eur;

      const res = await fetch(`${BASE_URL_SSD}/typecurves`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
          'email': email
        },
        body: JSON.stringify({typecurve: newTypeCurve})
      });
  
      if (res.status === 200) {
        console.log('Type curve ' + typeCurve?.name + ' saved to the database successfully!');
        return { success: true };
      } else {
        console.log('Could not save type curve ' + typeCurve?.name + '!');
        return { success: false };
      };
    } else {
      console.log('Please provide a valid type curve');
      return { success: false };
    };
    
  } catch (error) {
    console.log('Error saving type curve!');
    console.log(error);
    return { success: false };
  };
};


export const deleteTypeCurveApi = async (typeCurveId, email) => {
  try {
    console.log('Deleting type curve ' + typeCurveId + '...');

    const res = await fetch(`${BASE_URL_SSD}/typecurves`, {
      method: 'DELETE',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        'email': email
      },
      body: JSON.stringify({id: typeCurveId})
    });
    if (res.status === 200) {
      console.log('Type curve ' + typeCurveId + ' deleted from the database');
      return true;
    } else {
      console.log('Could not delete type curve ' + typeCurveId + '!');
      return false;
    };
    
  } catch (error) {
    console.log('Error deleting type curve!');
    console.log(error);
    return false;
  };
};

export const deleteTypeCurveParamsApi = async (typeCurveId, email) => {
  try {
    console.log('Deleting forecast parameters for type curve ' + typeCurveId + '...');

    const res = await fetch(`${BASE_URL_SSD}/typecurves`, {
      method: 'DELETE',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        'email': email,
        'id': typeCurveId
      },
    });
    if (res.status === 200) {
      console.log('Forecast parameters deleted for type curve ' + typeCurveId);
      return true;
    } else {
      console.log('Could not delete forecast parameters for type curve ' + typeCurveId + '!');
      return false;
    };
    
  } catch (error) {
    console.log('Error deleting forecast parameters!');
    console.log(error);
    return false;
  };
};

export const loadTypeCurveAPI = async (location, id, userEmail) => {

  try {
    console.log('Loading type curve from ' + location + '...');

    let result = await fetch(location);

    if (result.status === 200) {
      let typeCurve = await result.json();

      return {...typeCurve, location: location, id: id, createdBy: userEmail};
    } else {
      return null;
    };
  } catch (error) {
    console.error('Error loading type curve!');
    console.error(error);
    return null;
  };
};